export default __webpack_public_path__ + "static/media/CNo.87-3.d61951fa.jpg";